<template>
  <app-tooltip :top="!tooltipBottom" :bottom="tooltipBottom">
    <template #activator="{ on }">
      <v-chip
        :close="removable"
        small
        :label="!rounded"
        :color="color"
        class="ml-0 my-1"
        :class="{ tag: !rounded, 'mr-2': rightMargin, 'pl-0': noLeftPadding }"
        v-on="on"
        :data-e2e-id="kebab(`${name}-filter-chip`)"
        @click="chipClicked(name)"
        @update:active="removed()"
      >
        <span
          :style="chipContentStyle"
          :class="{ 'text-truncate': true }"
          class="font-weight-medium caption"
        >
          <slot>{{ name }}</slot>
        </span>
      </v-chip>
    </template>
    <span>{{ name }}</span>
  </app-tooltip>
</template>

<script>
export default {
  props: {
    maxWidth: { type: Number, default: 200 },
    name: { type: String, default: '' },
    color: { type: String, default: null },
    removable: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    noLeftPadding: { type: Boolean, default: false },
    rightMargin: { type: Boolean, default: true },
    tooltipBottom: { type: Boolean, default: false },
    truncateText: { type: Boolean, default: true }
  },
  computed: {
    chipContentStyle() {
      return this.truncateText
        ? {
            maxWidth: this.maxWidth + 'px'
          }
        : {}
    }
  },
  methods: {
    removed() {
      this.$emit('removed')
    },
    chipClicked(name) {
      this.$emit('chipClicked', name)
    },
    kebab(name) {
      return _.kebabCase(name)
    }
  }
}
</script>

<style lang="scss" scoped>
.tag {
  border-radius: 4px;
}
</style>
